module.exports = __webpack_public_path__ + "img/13.78037f06.svg";